import type { CreditsResponse } from '@/types/monetization';

/**
 * Extract total credits from a credits response, handling both SDK formats.
 * Returns `null` when the response carries no credit info — callers must not
 * read that as a zero balance.
 */
const getTotalCredits = (response: CreditsResponse): number | null => {
  const info = response.creditsInfo ?? response.creditInfo;
  if (typeof info?.credits !== 'number') return null;
  return info.credits + (info.addonCredits ?? 0);
};

export default getTotalCredits;
